import type { UserType } from '@shared/store/exchangeSlice';

export const userTypes = {
  Crackle_Admin: 'C-ADMIN',
  Crackle_User: 'C-USER',
  Demand_Partner_Admin: 'DP-ADMIN',
  Demand_Partner_User: 'DP-USER',
  Supply_Partner_Admin: 'SP-ADMIN',
  Supply_Partner_Tech: 'SP-TECH',
  Supply_Partner_Ops: 'SP-OPS'
} as const satisfies Record<string, UserType>;

export type AppPageKey = 'home' | 'userManagement' | 'partnerManagement' | 'configDetails' | 'reports';

export const pageAccessMap: Record<AppPageKey, UserType[]> = {
  home: [
    userTypes.Crackle_Admin,
    userTypes.Crackle_User,
    // userTypes.Demand_Partner_Admin,
    // userTypes.Demand_Partner_User,
    userTypes.Supply_Partner_Admin,
    userTypes.Supply_Partner_Tech,
    userTypes.Supply_Partner_Ops
  ],
  userManagement: [
    userTypes.Crackle_Admin,
    // userTypes.Demand_Partner_Admin,
    userTypes.Supply_Partner_Admin
  ],
  partnerManagement: [
    userTypes.Crackle_Admin,
    userTypes.Crackle_User,
  ],
  configDetails: [
    userTypes.Crackle_Admin,
    userTypes.Crackle_User,
  ],
  reports: [
    userTypes.Crackle_Admin,
    userTypes.Crackle_User,
    userTypes.Supply_Partner_Admin,
    userTypes.Supply_Partner_Tech,
    userTypes.Supply_Partner_Ops
  ]
};

export const canAccessPage = (userType: UserType | null | undefined, page: AppPageKey) => {
  if (!userType) {
    return false;
  }
  return pageAccessMap[page].includes(userType);
};
